import { createContext } from 'react';

export const DataAugmentationConfigContext = createContext();
